import { PrimaryButton } from "@/ui/buttons/Button";
import { SearchInput } from "@/ui/inputs/Input";
import React, { useEffect, useState, useRef } from "react";
import useTableService from "../useTableServerSide";
import Footer from "../Footer";
import { Dimmer } from "../spinner";
import moment from "moment";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Egresos } from "./modalActualizarEgresos";
import ValidarUsuario from "../comun/modalValidarUsuario";
export default function TablaEgresos(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const idefiscal = localStorage.getItem("idefiscal");
  const espiritu = localStorage.getItem("espiritu");
  const searchTimeoutRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [showUsuario, setShowUsuario] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [egreso, setEgreso] = useState();
  const [gastos, setGastos] = useState([]);
  const [moviBanco, setMoviBanco] = useState();
  const [egresoDetalle, setEgresoDetalle] = useState();
  const [showModal, setShowModal] = useState(false);
  const [totales, setTotales] = useState({
    total: 0,
    pagadas: 0,
    porPagar: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CONCEPTO",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];
  const cardsData = [
    {
      title: "Total Egresos",
      value: totales.total || 0,
      color: "#053160",
      icon: "fas fa-toggle-on fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
    {
      title: "Egresos Pagados",
      value: totales.pagadas || 0,
      color: "#76b8e8",
      icon: "fas fa-toggle-on fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
    {
      title: "Egresos Por Pagar",
      value: totales.porPagar || 0,
      color: "#ca4117",
      icon: "fas fa-toggle-off fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
  ];
  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };
  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };
  const buscarClaseGastos = async () => {
    try {
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=*&nomtab=clasegasto&orden=idclasegasto`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        setGastos(response.data);
      }
    } catch (error) {
      console.error("Error cargando catálogos:", error);
    }
  };
  const buscarRegistrosEgresos = () => {
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      efi: idefiscal,
    };
    const endpoint = `${op.conexion}/api/administracion/registroschequesemitidos`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          const { rows, count, totales } = response.data;
          setRecords(rows);
          setTotalRecords(count);
          setTotales({
            total: totales.total,
            pagadas: totales.pagado,
            porPagar: totales.por_pagar,
          });
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  };
  const buscarEgreso = async ({ idEgreso }) => {
    setLoading(true);
    try {
      const resEgreso = await axios.get(
        `${op.conexion}/api/consulta/modelicondi?campos=*&id=${idEgreso}&nomtab=chequeemitido&nomid=idchequeemitido&condic=idefiscal=${idefiscal}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataEgreso = resEgreso.data;
      setEgreso(dataEgreso);
      const resEgresoDet = await axios.get(
        `${op.conexion}/api/administracion/registrochequesemitidodetalle?efi=${idefiscal}&idcheemi=${idEgreso}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataEgresoDet = resEgresoDet.data;
      setEgresoDetalle(dataEgresoDet);
      const resMovCheque = await axios.get(
        `${op.conexion}/api/administracion/seleccionarmovimientosbancocheque?idcheque=${idEgreso}&idefi=${idefiscal}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataMovCheque = resMovCheque.data;
      setMoviBanco(dataMovCheque);
      setShowModal(true);
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message ||
          "Error al cargar la información del proveedor",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const operaciones = ({ ope, idEgreso, reversado, permitireliminar }) => {
    setOperacion(ope);
    if (ope > 1) {
      if (ope === 2 && reversado === 1) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡El Egreso esta reversado!",
          icono: "error",
        });
      } else if (ope === 3) {
        if (reversado === 0) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡El Egreso no ha sido Reversado!",
            icono: "error",
          });
        } else if (permitireliminar === 0) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡El Egreso no ha sido autorizado para eliminar!",
            icono: "error",
          });
        } else {
          setShowUsuario(true);
          return;
        }
      } else {
        buscarEgreso({
          idEgreso,
        });
      }
    } else {
      setShowModal(true);
    }
  };
  const cerrar = () => {
    props.setTabla(0);
  };
  useEffect(() => {
    if (parseInt(espiritu) === 0) {
      buscarClaseGastos();
    }
    const cleanup = buscarRegistrosEgresos();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);
  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", height: "90vh" }}
    >
      <div className="row g-3 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-4 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <span
                      className="text-uppercase small fw-bold opacity-75"
                      style={{ letterSpacing: "2px", fontSize: "1rem" }}
                    >
                      {card.title}
                    </span>
                    <h2
                      className="fw-bold mb-0 mt-1"
                      style={{ fontSize: "2.2rem" }}
                    >
                      {card.value}
                    </h2>
                  </div>
                  <i
                    className={card.icon}
                    style={{ color: card.iconColor }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="row g-4">
        <div className="col-12">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-header azulGradiant text-white d-flex justify-content-between">
              <h5 className="mb-0 fw-bold text-uppercase">Egresos</h5>
              <a
                type="button"
                className="text-light fw-bold fs-6"
                onClick={() => cerrar()}
                style={{ cursor: "pointer" }}
              >
                <i className="fas fa-times ms-2" />
              </a>
            </div>
            <div className="card-body p-0 m-0">
              <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
                <div className="col-4 m-0 p-0 position-relative">
                  <SearchInput
                    className="search-input pe-4"
                    value={searchInput}
                    onChange={handleSearch}
                  />
                </div>
                <div className="col-auto mx-2 p-0">
                  <PrimaryButton
                    onClick={() => {
                      operaciones({
                        ope: 1,
                        idEgreso: "",
                        reversado: "",
                        permitireliminar: "",
                      });
                    }}
                    icon="fa-plus m-0 p-0"
                  />
                </div>
              </div>
              <section className="col-12 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr key={index} style={{ padding: "0" }}>
                          <td
                            style={{
                              fontSize: "12px",
                              textAlign: "center",
                              width: "10px",
                            }}
                          >
                            {item.idchequeemitido}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              textAlign: "left",
                              width: "auto",
                            }}
                          >
                            {item.concepto.trim()}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              textAlign: "center",
                              width: "10px",
                            }}
                          >
                            {moment.utc(item.fecha).format("DD/MM/YYYY")}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              textAlign: "center",
                              width: "120px",
                            }}
                          >
                            <button
                              onClick={() => {
                                operaciones({
                                  ope: 4,
                                  idEgreso: item.idchequeemitido,
                                  reversado: item.reversado,
                                  permitireliminar: item.permitireliminar,
                                });
                              }}
                              className="btn btn-sm mx-1 btn-info rounded-circle"
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                            <button
                              onClick={() => {
                                operaciones({
                                  ope: 2,
                                  idEgreso: item.idchequeemitido,
                                  reversado: item.reversado,
                                  permitireliminar: item.permitireliminar,
                                });
                              }}
                              className="btn btn-sm mx-1 btn-success rounded-pill"
                            >
                              <i className="fas fa-sync-alt"></i>
                            </button>
                            <button
                              onClick={() => {
                                operaciones({
                                  ope: 3,
                                  idEgreso: item.idchequeemitido,
                                  reversado: item.reversado,
                                  permitireliminar: item.permitireliminar,
                                });
                              }}
                              className="btn btn-sm mx-1 btn-danger rounded-pill"
                            >
                              <i className="fas fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </section>
            </div>
          </div>
        </div>
      </div>
      <Egresos
        show={showModal}
        gastos={gastos}
        operacion={operacion}
        movibanco={moviBanco}
        egreso={egreso}
        egresodetalle={egresoDetalle}
        onHideCancelar={() => setShowModal(false)}
        onHideRenderizar={() => {
          setShowModal(false);
          buscarRegistrosEgresos();
        }}
      />
      <ValidarUsuario
        show={showUsuario}
        onHideCancela={() => setShowUsuario(false)}
        llamado={1}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
